module.exports = __webpack_public_path__ + "static/media/ok.eb23a497.png";